import Highcharts from 'highcharts';

export const serviceStatisticsACoreConfig = {
  chart: {
    type: 'bar',
    height: '1000px',
  },
  title: {
    text: '',
  },
  xAxis: {
    categories: Array(29).fill('').map((_, idx) => 2023 - idx),
    title: {
      text: null,
    },
    labels: {
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
  },
  // colorAxis: {
  //   marker: '#805a35',
  // },
  yAxis: {
    min: 0,
    max: 4000,
    title: {
      text: '',
      align: 'high',
    },
    labels: {
      overflow: 'justify',
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
  },
  colors: ['#F9DB4A', '#BFAD9A'],
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true,
      },
    },
  },
  series: [
    {
      name: '追蹤個案人次',
      data: [
        2739, 2837, 2866, 3003, 3191, 2995, 3135, 3361, 3159, 3256, 3316, 2855, 2543, 2362, 1998, 1918, 1941, 2031, 2103,
        2126, 1962, 2350, 2360, 2245, 2141, 2357, 2184, 0, 0,
      ],
      dataLabels: {
        color: '#805a35',
        formatter() {
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
    },
    {
      name: '收案個案數',
      data: [
        1070, 1002, 1173, 1170, 1163, 1199, 1222, 1403, 1398, 1325, 1203, 1372, 1320, 888, 899, 885, 789, 811, 825, 881, 851,
        954, 945, 1152, 977, 919, 982, 802, 387,
      ],
      dataLabels: {
        color: '#805a35',
        formatter() {
          console.log('thissssss', this);
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
    },
  ],
};

export const serviceStatisticsBExpandConfig = {
  chart: {
    zoomType: 'xy',
  },
  title: {
    text: '',
  },
  xAxis: [
    {
      // categories: [
      //   '2009',
      //   '2010',
      //   '2011',
      //   '2012',
      //   '2013',
      //   '2014',
      //   '2015',
      //   '2016',
      //   '2017',
      //   '2018',
      //   '2019',
      //   '2020',
      //   '2021',
      //   '2022',
      // ],
      categories: Array(15).fill('').map((_, idx) => 2009 + idx),
      crosshair: true,
      labels: {
        style: {
          color: '#805a35',
          fontSize: '14px',
        },
      },
    },
    {
      title: {
        text: '點擊可呈現單項歷年數據',
        style: {
          transform: 'translateY(50px) translateX(-10px)',
          color: '#999999',
          fontSize: '11px',
        },
      },
    },
  ],
  yAxis: [
    {
      // Secondary yAxis
      min: 0,
      max: 18,

      title: {
        text: '',
        style: {
          color: Highcharts.getOptions().colors[0],
        },
      },
      labels: {
        format: '{value}%',
        // style: {
        //   color: Highcharts.getOptions().colors[0],
        // },
        style: {
          color: '#805a35',
          fontSize: '14px',
        },
      },
      opposite: true,
    },
    {
      // Primary yAxis
      min: 0,
      max: 300,

      labels: {
        style: {
          color: '#805a35',
          fontSize: '14px',
        },
      },
      title: {
        text: '',
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
    },
  ],
  // tooltip: {
  //   shared: true,
  // },
  plotOptions: {
    column: {
      dataLabels: {
        enabled: true,
        color: '#805a35',
      },
    },
    spline: {
      dataLabels: {
        enabled: true,
        color: '#FF000A',
        format: '{point.y}%',
      },
    },
  },
  series: [
    {
      name: '與國健署比較',
      type: 'spline',
      data: [0.6, 9.73, 8.17, 9.73, 9.86, 8.87, 10.1, 10.29, 14.37, 15.74, 13.62, 14.96, 14.68, 17.98, 9.15],
      color: '#ff0000',
      zIndex: 10,
    },
    {
      name: '擴大追蹤收案數',
      type: 'column',
      yAxis: 1,
      data: [9, 136, 145, 187, 164, 162, 196, 199, 259, 273, 227, 249, 248, 264, 133],
      color: '#F9DB4A',
    },
  ],
};

// for future developer: 橘色占比的線，是硬幹上去的，因百分比與y軸無法匹配，所以用一個最大值換算位置，所以有了各種formatter
export const serviceStatisticsABExpand19982008Config = {
  title: {
    text: '',
  },
  xAxis: {
    // categories: ['Apples', 'Oranges', 'Pears', 'Bananas', 'Plums'],
    categories: [
      '1995',
      '1996',
      '1997',
      '1998',
      '1999',
      '2000',
      '2001',
      '2002',
      '2003',
      '2004',
      '2005',
      '2006',
      '2007',
      '2008',
    ],
    labels: {
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
    title: {
      text: '出生年度',
      style: {
        fontSize: '16px',
        fontWeight: 700,
        // writingMode: 'vertical-rl',
      },
    },
  },
  yAxis: [{
    labels: {
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
    title: {
      text: '收案人數',
      // rotation: 0,
      style: {
        // width: '20px',
        fontSize: '16px',
        fontWeight: 700,
        // writingMode: 'vertical-rl',
      },
    },
  },
  {
    // Secondary yAxis
    min: 0,
    max: 100,
    tickAmount: 5,
    title: {
      text: '',
      style: {
        color: Highcharts.getOptions().colors[0],
      },
    },
    labels: {
      format: '{value}%',
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
    opposite: true,
  },
  ],
  plotOptions: {
    column: {
      dataLabels: {
        enabled: true,
        color: '#805a35',
      },
    },
    spline: {
      dataLabels: {
        enabled: true,
        color: '#FF000A',
        // format: '{point.y}%',
      },
    },
    line: {
      dataLabels: {
        enabled: true,
        color: '#ed9121',
        // format: '{y}%',
        formatter() {
          console.log('this', this);

          return `${(this.y / 2000) * 100}%`;
        },
      },
    },
  },
  tooltip: {
    // enabled: false,
    formatter(tooltip) {
      if (this.series.userOptions.type === 'line') {
        return `${this.x} <br> ${this.series.name}: ${((this.y / 2000) * 100).toFixed(2)}%`;
      }

      return tooltip.defaultFormatter.call(this, tooltip);
    },
  },
  series: [
    {
      name: '核心院區收案數',
      type: 'column',
      data: [387, 802, 982, 919, 977, 1152, 945, 954, 851, 881, 825, 811, 789, 885],
      dataLabels: {
        formatter() {
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
      color: '#F9DB4A',
    },

    {
      name: '國健署出生通報數',
      type: 'column',
      data: [null, null, null, null, null, null, null, null, null, 1659, 1551, 1526, 1591, 1562],
      dataLabels: {
        formatter() {
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
      color: '#ff0000',
    },
    {
      name: '核心院區收案數與國健署占比',
      type: 'line',
      // data: [null, null, null, null, null, null, null, null, null, 53.10, 53.19, 53.15, 49.59, 56.66],
      // data: [null, null, null, null, null, null, null, null, null, 881, 825, 811, 789, 885],
      data: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        2000 * 0.531,
        2000 * 0.5319,
        2000 * 0.5315,
        2000 * 0.4959,
        2000 * 0.5666,
      ],
      color: '#ed9121',
    },
  ],
};

export const serviceStatisticsABExpand19982008Config1 = {
  title: {
    text: '',
  },
  xAxis: {
    title: {
      text: '點擊可呈現單項歷年數據',
      style: {
        transform: 'translateY(50px) translateX(-10px)',
        color: '#999999',
        fontSize: '11px',
      },
    },
    categories: [
      '1995',
      '1996',
      '1997',
      '1998',
      '1999',
      '2000',
      '2001',
      '2002',
      '2003',
      '2004',
      '2005',
      '2006',
      '2007',
      '2008',
    ],
    crosshair: true,
    labels: {
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
  },

  series: [
    {
      name: '國健署出生通報數',
      type: 'spline',
      data: [null, null, null, null, null, null, null, null, null, 1659, 1551, 1526, 1591, 1562],
      color: '#ff0000',
      zIndex: 10,
    },
    {
      name: '核心院區收案數',
      type: 'column',
      yAxis: 1,
      data: [387, 802, 982, 919, 977, 1152, 945, 954, 851, 881, 825, 811, 789, 885],
      color: '#F9DB4A',
    },

    // {
    //   name: '追蹤22家收案數與國健署占比',
    //   type: 'spline',
    //   yAxis: 1,
    //   data: [null, null, null, null, null, null, null, null, null,
    //     1659 * 0.531 + 300,
    //     1551 * 0.5319 + 300,
    //     1526 * 0.5315 + 300,
    //     1591 * 0.4959 + 300,
    //     1562 * 0.5666 + 300],
    //   tooltip: {
    //     valueSuffix: ' mm',
    //   },
    //   color: '#BA2424',
    // },
  ],
};

export const serviceStatisticsABExpandConfig = {
  chart: {
    zoomType: 'xy',
  },
  title: {
    text: '',
  },

  xAxis: [
    {
      // categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022],
      categories: Array(15).fill('').map((_, idx) => 2009 + idx),
      crosshair: true,
      labels: {
        style: {
          color: '#805a35',
          fontSize: '14px',
        },
      },
    },
    {
      title: {
        text: '點擊可呈現單項歷年數據',
        style: {
          transform: 'translateY(50px) translateX(-10px)',
          color: '#999999',
          fontSize: '11px',
        },
      },
    },
  ],
  yAxis: [
    {
      min: 0,
      max: 100,
      // Secondary yAxis
      title: {
        text: '',
        style: {
          color: '#805a35',
        },
      },
      labels: {
        format: '{value}%',
        style: {
          color: '#805a35',
          fontSize: '16px',
        },
      },
      opposite: true,
    },
    {
      // Primary yAxis
      min: 0,
      max: 2000,
      labels: {
        style: {
          color: '#805a35',
          fontSize: '16px',
        },
      },
      title: {
        text: '',
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
    },
  ],
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: true,
        color: '#805A35',
      },
    },
    spline: {
      dataLabels: {
        enabled: true,
        format: '{point.y}%',
        color: '#805A35',
      },
    },
  },
  series: [
    {
      name: '擴大追蹤收案數',
      type: 'column',
      yAxis: 1,
      data: [214, 294, 145, 187, 164, 162, 196, 199, 259, 273, 227, 249, 248, 264, 133],
      dataLabels: {
        formatter() {
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
      stack: 'totalCount',
      color: '#F9DB4A',
    },
    {
      name: '核心院區收案數',
      type: 'column',
      yAxis: 1,
      data: [899, 888, 1320, 1372, 1203, 1325, 1398, 1403, 1222, 1199, 1163, 1170, 1173, 1002, 1070],
      dataLabels: {
        formatter() {
          return Highcharts.numberFormat(this.y, 0, '.', ',');
        },
      },
      stack: 'totalCount',
      color: '#8cdbd6',
    },

    {
      name: '核心院區收案數與國健署占比',
      type: 'spline',
      data: [60.01, 63.52, 74.41, 71.38, 72.3, 72.56, 72.02, 72.54, 67.81, 69.15, 69.77, 70.31, 69.45, 68.26, 73.64],
      color: '#8cdbd6',
    },
    {
      name: '全國總收案數占比',
      type: 'spline',
      data: [74.3, 84.55, 82.58, 81.11, 82.15, 81.43, 82.12, 82.83, 82.19, 84.89, 83.38, 85.28, 84.13, 86.24, 82.79],
      dataLabels: {
        color: '#FF000A',
      },
      color: '#FF000A',
    },
  ],
};

const expandLastData = [
  100.0,
  100.0,
  100.0,
  100.0,
  97.5,

  92.1,
  89.6,
  88.4,
  88.1,
  84.9,

  82.8,
  79.3,
  77.6,
  75.0,
  72.0,

  69.6,
  67.6,
  65.0,
  62.1,
  55.6,

  42.9,
  0.0,
  0.0,
];

const expandLastDataTotal = expandLastData.reduce((total, val) => {
  total += val;

  return total;
}, 0);

let accumulateTotal = 0;
const accumulateData = expandLastData.map((val) => {
  accumulateTotal += val;
  return Math.round((accumulateTotal / expandLastDataTotal) * 10000) / 100;
});

export const serviceStatisticsABExpandLastConfig = {
  chart: {
    type: 'column',
  },
  title: {
    text: '',
  },
  // subtitle: {
  //   text: 'Source: WorldClimate.com',
  // },
  xAxis: {
    title: {
      text: '點擊可呈現單項歷年數據',
      style: {
        transform: 'translateY(50px) translateX(-10px)',
        color: '#999999',
        fontSize: '11px',
      },
    },
    categories: [
      '金門縣',
      '基隆市',
      '南投縣',
      '澎湖縣',
      '彰化縣',
      '台北市',
      '台中市',
      '屏東縣',
      '高雄市',
      '桃園市',
      '台南市',
      '嘉義縣',
      '新竹縣',
      '嘉義市',
      '新北市',
      '花蓮縣',
      '雲林縣',
      '台東縣',
      '宜蘭縣',
      '新竹市',
      '苗栗縣',
      '連江縣',
      '其他',
    ],
    crosshair: true,
    labels: {
      style: {
        color: '#805a35',
        fontSize: '14px',
      },
    },
  },
  yAxis: {
    min: 0,
    max: 100,
    title: {
      text: '',
    },
    labels: {
      style: {
        color: '#805a35',
        fontSize: '16px',
      },
    },
  },
  // tooltip: {
  //   headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
  //   pointFormat:
  //     '<tr><td style="color:{series.color};padding:0">{series.name}: </td>'
  //     + '<td style="padding:0"><b>{point.y:.1f} %</b></td></tr>',
  //   footerFormat: '</table>',
  //   shared: true,
  //   useHTML: true,
  // },
  plotOptions: {
    spline: {
      dataLabels: {
        enabled: true,
        color: '#FF000A',
        format: '{point.y}%',
      },
    },
    column: {
      dataLabels: {
        enabled: true,
        color: '#805a35',
        format: '{point.y}%',
      },
    },
  },
  series: [
    {
      name: '各縣市收案比率',
      data: expandLastData,
      color: '#8cdbd6',
    },
    {
      name: '累計收案比率',
      type: 'spline',
      // data: [null, null, null, null, null, null, null, null, null, 1659, 1551, 1526, 1591, 1562],
      data: accumulateData,
      color: '#ff0000',
      zIndex: 10,
    },
  ],
};
